import {REQUEST_STATE} from '@/iamteacherpc/consts/request.js';
import {ANSWER_TYPE} from '@/common/consts/survey.js';
import {availableSubQuestions} from '@common/utils/question';

/**
 * 이미지 정보 관리를 위한 클래스
 */
export class ImageManagerForPayload {
    constructor() {
        this.imageMap = new Map();
        this.imageIndex = 0;
    }

    /**
     * 중복된 이미지를 처리하여 이미지 정보를 반환
     * @param image
     * @returns {null|V|{imageNo: (*|string), index: number, url: *}}
     */
    setOrGetImage(image) {
        if (!image || image.uploadState !== REQUEST_STATE.SUCCESS) {
            return null;
        }

        const existImage = this.imageMap.get(image.imageNo);
        if (existImage) {
            return existImage;
        }

        const newImage = {
            imageNo: image.imageNo,
            index: this.imageIndex++,
            url: image.url,
        };

        this.imageMap.set(image.imageNo, newImage);
        return newImage;
    }
}

/**
 * 이미지 정보 관리를 위한 클래스 (리퀘스트 인포용)
 */
export class ImageManagerForRequestInfo {
    constructor() {
        this.imageNoSet = new Set();
        this.attachments = [];
    }

    /**
     * 중복을 제거한 attachments를 반환
     * @param form
     * @returns {Array}
     */
    getAttachments(form) {
        this._addFormAttachment(form);
        this._processQuestions(form.questions);
        return this.attachments;
    }

    _processQuestions(questions) {
        questions.forEach(question => {
            if (!question.parentQuestion || question.parentQuestion.type !== ANSWER_TYPE.TABLE) {
                this._addQuestionAttachment(question);
            }

            if (question.type === ANSWER_TYPE.ONE_CHOICE || question.type === ANSWER_TYPE.MULTI_CHOICE) {
                question.answers.forEach(answer => this._addQuestionAttachment(answer));
            }

            if (!availableSubQuestions({question}) || question.isParentFCFS) {
                return;
            }

            if (question.questions && question.questions.length) {
                this._processQuestions(question.questions);
            }
        });
    }

    _addQuestionAttachment(obj) {
        if (!obj.image || obj.image.uploadState !== REQUEST_STATE.SUCCESS) {
            return;
        }

        if (this.imageNoSet.has(obj.image.imageNo)) {
            return;
        }

        this.attachments.push({
            type: 'IMAGE',
            attachmentNo: obj.image.imageNo,
            description: null,
        });

        this.imageNoSet.add(obj.image.imageNo);
    }

    _addFormAttachment(obj) {
        if (!obj.images || obj.images.some(i => i.uploadState !== REQUEST_STATE.SUCCESS)) {
            return;
        }

        obj.images.forEach(image => {
            if (this.imageNoSet.has(image.imageNo)) {
                return;
            }

            this.attachments.push({
                type: 'IMAGE',
                attachmentNo: image.imageNo,
                description: null,
            });

            this.imageNoSet.add(image.imageNo);
        });
    }
}
